import React, { useState, useEffect, useRef } from "react";
import { Fragment } from "react";
import { Translate } from "orion-components/i18n";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";

const CustomFilesDropContainer = ({ getDropZoneAction, entityType, contextId }) => {
	const [isDragging, setIsDragging] = useState(false);
	const [isHovering, setIsHovering] = useState(false);
	const wrapperRef = useRef(null);

	const dispatch = useDispatch();

	const handleDragEnter = () => setIsDragging(true);

	const handleDragOver = event => event.preventDefault();

	const handleDragLeave = event => {
		// Only clear when leaving the browser window entirely
		if (
			event.clientY <= 0 ||
			event.clientX <= 0 ||
			event.clientX >= window.innerWidth ||
			event.clientY >= window.innerHeight
		) {
			setIsDragging(false);
			setIsHovering(false);
		}
	};

	const handleDrop = () => {
		setIsDragging(false);
		setIsHovering(false);
	};

	useEffect(() => {
		// Add event listeners for drag and drop events to the document
		document.addEventListener("dragenter", handleDragEnter);
		document.addEventListener("dragover", handleDragOver);
		document.addEventListener("dragleave", handleDragLeave);
		document.addEventListener("drop", handleDrop);

		// Clean up event listeners on component unmount
		return () => {
			document.removeEventListener("dragenter", handleDragEnter);
			document.removeEventListener("dragover", handleDragOver);
			document.removeEventListener("dragleave", handleDragLeave);
			document.removeEventListener("drop", handleDrop);
		};
	}, []);

	return (
		<Fragment>
			{isDragging && (
				<div
					ref={wrapperRef}
					className={`fileDropContainer ${isHovering ? "fileHover" : ""}`}
					data-testid="file-widget-dropzone"
					onDragEnter={event => {
						if (event.dataTransfer.items.length > 0) {
							setIsHovering(true);
						}
					}}
					onDragLeave={event => {
						if (!wrapperRef.current.contains(event.relatedTarget)) {
							setIsHovering(false);
						}
					}}
					onDrop={event => {
						event.preventDefault();
						const { files } = event.dataTransfer;
						const attachAction = getDropZoneAction(entityType);
						dispatch(attachAction(contextId, entityType, files));

						setIsDragging(false);
						setIsHovering(false);
					}}
				>
					{isHovering && (
						<>
							<div data-testid="file-widget-dropzone-message">
								<Translate value="global.profiles.widgets.files.dropFiles" />
							</div>
							<div className="fileOverlay" />
						</>
					)}
				</div>
			)}
		</Fragment>
	);
};

CustomFilesDropContainer.propTypes = {
	getDropZoneAction: PropTypes.func.isRequired,
	entityType: PropTypes.string.isRequired,
	contextId: PropTypes.string.isRequired
};

export default CustomFilesDropContainer;
